import {
  Component,
  OnInit,
  HostListener,
  OnDestroy,
  Input,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { NotifierService } from 'angular-notifier';
import { FormControl } from '@angular/forms';
import { GlobalApiService } from 'src/app/services/global-api.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
})
export class UserDetailsComponent implements OnInit, OnDestroy {
  paramSubmscription: Subscription;
  firstName = '';
  lastName = '';
  email = '';
  mobile = '';
  skype = '';
  zip = '';
  address = '';
  myChildren = <any>[];
  gender: number | null = null;
  role: number | null = null;
  addNewChild = false;
  @Input() userId: number | null = null;
  students = <any>[];
  parentChildren = <any>[];
  studentParents = <any>[];
  selectedChildren = <any>[];
  defaultSelectedChildren = <any>[];
  users = [];
  courses: any[] = [];
  selectedCourses: any[] = [];
  requestedCourses: any[] = [];
  saveCoursesClicked = false;
  // children = new FormControl();
  addingChildren = false;
  error = false;
  mobileNav = false;
  texts: string[] = [];

  results: string[] = [];

  courseStatus: any = {};
  user: any = {};

  private readonly notifier: NotifierService;
  constructor(
    private httpClient: HttpClient,
    notifierService: NotifierService,
    private router: Router,
    private route: ActivatedRoute,
    private globalApiService: GlobalApiService,
    private commonService: CommonService
  ) {
    this.notifier = notifierService;
    this.paramSubmscription = this.route.params.subscribe((params: Params) => {
      this.userId = params['userId'];
    });
  }

  ngOnInit() {
    this.globalApiService.getUserByUserId(this.userId!).subscribe(
      (response: any) => {
        console.log(response);
        this.firstName = response['first_name'] ? response['first_name'] : '';
        this.lastName = response['last_name'] ? response['last_name'] : '';
        this.email = response['email'] ? response['email'] : '';
        this.mobile = response['mobile']
          ? `${response['country']} ${response['mobile']}`
          : '';
        this.skype = response['skype'] ? response['skype'] : '';
        this.zip = response['zipcode'] ? response['zipcode'] : '';
        this.address = response['address'] ? response['address'] : '';
        this.gender = response['gender'] ? response['gender'] : '';
        this.role = response['role_id'] ? response['role_id'] : '';

        this.user.createdOn = response['created_on']
          ? new Date(response['created_on'])
          : '';
        this.user.status = response['status'] ?? '';

        if (response['role_id'] === 4) {
          this.parentChildren = response['childrens']
            ? response['childrens']
            : [];
          // this.parentChildren = [];
          // if (response["childrens"]) {
          //   for (let i = 0; i < response["childrens"].length; i++) {
          //     this.parentChildren.push({ value: response["childrens"][i] });
          //   }
          // }
          // this.children.setValue(
          //   response["childrens"] ? response["childrens"] : []
          // );
          this.defaultSelectedChildren = response['childrens']
            ? response['childrens']
            : [];
          this.selectedChildren = [...this.defaultSelectedChildren];
        } else if (response['role_id'] === 3) {
          this.studentParents = response['parents'] ? response['parents'] : [];
        }
        if (response['role_id'] === 3 || response['role_id'] === 4) {
          this.myChildren = response['childs']
            ? JSON.parse(response['childs'])
            : [];
          console.log(this.myChildren);
        }
        this.requestedCourses = response['requested_courses'] || [];
        this.requestedCourses.forEach((course) => {
          this.courseStatus[course.courseId] = course.status;
          delete course['status'];
        });
        this.fetchUsers();
        this.fetchCourses();
      },
      (error) => {
        console.log(error);
        this.notifier.notify('error', 'Unable to fetch data');
        this.fetchUsers();
      }
    );
  }

  search(event: any) {
    console.log(event);
    this.results = this.students.filter();
  }

  fetchUsers() {
    this.globalApiService
      .getAllUsers({
        userStatusId: 3,
        roleId: null,
        searchText: null,
        filterByChild: false,
      })
      .subscribe(
        (response: any) => {
          this.users = response;
          for (let i = 0; i < response.length; i++) {
            if (response[i]['role_id'] === 3) {
              this.students.push(response[i]);
            }
          }
          console.log(this.students);
          const studentParents = this.studentParents.map(
            (studentParent: any) =>
              this.users[
                this.users.findIndex(
                  (user: any) => user.email === studentParent
                )
              ]
          );
          this.studentParents = studentParents;

          const parentChildren = this.parentChildren.map(
            (parentChild: any) =>
              this.users[
                this.users.findIndex((user: any) => user.email === parentChild)
              ]
          );
          this.parentChildren = parentChildren;
        },
        (error) => {
          this.notifier.notify('error', 'Unable to fetch data');
        }
      );
  }

  fetchCourses() {
    this.globalApiService.getCourses().subscribe(
      (response: any) => {
        console.log(response);
        this.courses = response.data ? response.data : [];
        this.selectedCourses = this.requestedCourses.sort(
          (current: any, next: any) => current.courseId - next.courseId
        );
        console.log('selected courses', this.selectedCourses);
      },
      (error) => {
        console.log(error);
        this.notifier.notify('error', 'Unable to fetch courses');
      }
    );
  }

  onCourseChange(event: any) {
    // this.courseStatus[event.itemValue.courseId] = true;
    // console.log(this.courseStatus);
    // console.log(event);
    const index = this.selectedCourses.findIndex((course) => {
      return event.value.courseId === course.courseId;
    });
    if (index < 0) {
      this.selectedCourses.push(event.value);
    }
    this.courseStatus[event.value.courseId] = 1;
  }

  setCoursesForUser() {
    this.saveCoursesClicked = true;
    if (!(this.role === 4 && this.selectedCourses.length === 0)) {
      this.globalApiService
        .updateRequestedCourses({
          requested_courses: this.selectedCourses
            .map((course: any) => {
              return {
                courseId: course.courseId,
                status: this.courseStatus[course.courseId],
              };
            })
            .sort(),
          user_id: this.userId,
        })
        .subscribe(
          (response) => {
            this.notifier.notify('success', 'Successfully updated courses');
            this.saveCoursesClicked = false;
          },
          (error) => {
            console.log(error);
            this.saveCoursesClicked = false;
            this.notifier.notify('error', 'Unable to update courses');
          }
        );
    } else {
      this.saveCoursesClicked = false;
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e: any) {
    let element: any = document.querySelector('.common-header');
    if (window.pageYOffset > element.clientHeight / 3) {
      element.classList.add('user-details__header__whiteBackground');
    } else {
      element.classList.remove('user-details__header__whiteBackground');
    }
  }

  logout() {
    // localStorage.clear();
    // this.router.navigate(['']);
    this.commonService.logout();
  }

  getSelectedChildren = (selected: any) => {
    this.selectedChildren = selected;
  };

  toggleAddNewChild = () => {
    this.addNewChild = !this.addNewChild;
    if (this.addNewChild) {
      this.selectedChildren = this.parentChildren.map(
        (parentChild: any) => parentChild.email
      );
      this.defaultSelectedChildren = this.selectedChildren;
    }
  };

  addChildToParent = () => {
    if (!this.addingChildren) {
      this.addingChildren = true;
      console.log(this.selectedChildren, this.defaultSelectedChildren);
      this.error = false;
      if (this.defaultSelectedChildren.length === 0) {
        this.error = true;
      }
      if (!this.error) {
        this.globalApiService
          .addParentStudent({
            parent_email: this.email,
            add_student: this.defaultSelectedChildren,
          })
          .subscribe(
            (response) => {
              console.log(response);
              // this.parentChildren = this.selectedChildren;
              console.log([...this.parentChildren]);
              const parentChildren = this.parentChildren.map(
                (parentChild: any) => parentChild.email
              );
              for (let i = 0; i < this.selectedChildren.length; i++) {
                if (parentChildren.indexOf(this.selectedChildren[i]) < 0) {
                  parentChildren.push(this.selectedChildren[i]);
                }
              }
              console.log([...parentChildren]);
              this.defaultSelectedChildren = parentChildren;
              this.selectedChildren = parentChildren;
              this.parentChildren = this.users.filter(
                (user: any) => parentChildren.indexOf(user.email) >= 0
              );
              // this.children.setValue([]);
              this.toggleAddNewChild();
              this.notifier.notify(
                'success',
                'Successfully added children to parent'
              );
              this.addingChildren = false;
            },
            (error) => {
              console.log(error);
              this.notifier.notify('error', 'Unable to add children to parent');
              this.addingChildren = false;
            }
          );
      } else {
        this.notifier.notify('warning', 'Select Children to add');
        this.addingChildren = false;
      }
    }
  };

  onMobileNav() {
    this.mobileNav = !this.mobileNav;
  }

  ngOnDestroy() {
    this.paramSubmscription.unsubscribe();
  }
}
